// @flow
import crypto from 'crypto'

export const encrypt = (text: string) => {
  const cipher = crypto.createCipher('aes-256-cbc', 'bedfordsq')
  let crypted = cipher.update(text, 'utf8', 'hex')
  crypted += cipher.final('hex')
  return crypted
}

export const decrypt = (text: string) => {
  const decipher = crypto.createDecipher('aes-256-cbc', 'bedfordsq')
  let dec = decipher.update(text, 'hex', 'utf8')
  dec += decipher.final('utf8')
  return { values: dec }
}



// WEBPACK FOOTER //
// ./src/helpers/encrypt.js